class VariantModalTrigger extends HTMLElement {
  constructor () {
    super()
    this.productHandle = this.dataset.productHandle
    this.productTitle = this.dataset.productTitle
    this.selectedVariantId = this.dataset.selectedVariant
    this.variants = JSON.parse(this.dataset.variants)
    this.productDescription = this.dataset.productDescription
    this.productLink = this.dataset.productLink
    this.variantOptions = this.dataset.variantOptions
    this.priceMarkup = this.dataset.priceMarkup
    this.stockStatusMarkup = this.dataset.stockStatusMarkup
    this.hasVariants = this.dataset.hasVariants === 'true' &&
      !(this.variants.length === 1 && this.variants[0].title === 'Default Title')
  }

  connectedCallback () {
    const buttons = this.querySelectorAll('button')
    buttons.forEach(button => button.addEventListener('click', this.handleClick.bind(this)))
  }

  async handleClick (event) {
    const button = event.target.closest('button')
    const isViewDetails = button.classList.contains('variant-modal-trigger__view-details-button')

    if (this.hasVariants && !isViewDetails) {
      this.handleVariantSelectionModal()
      return
    }

    const buttons = this.querySelectorAll('button')
    buttons.forEach(button => button.classList.add('loading'))
    this.setAttribute('loading', '')
    try {
      const basePath = (window?.Shopify?.routes?.root || '/')
      const response = await fetch(`${basePath}products/${this.productHandle}?section_id=main-product`)
      const html = await response.text()
      const parser = new DOMParser()
      const productSection = parser.parseFromString(html, 'text/html')
      const modalContent = this.buildModalContent(productSection)
      window.dispatchEvent(new CustomEvent('open:modal', {
        detail: {
          width: '500px',
          padding: 'none',
          headerClassAdd: isViewDetails ? ['absolute', 'h-[80px]', 'top-0', 'left-0', 'right-0', 'z-20', 'block'] : [],
          headerClassRemove: isViewDetails ? ['border-b', 'grid'] : [],
          bodyClassAdd: ['relative', 'z-10'],
          closeClassAdd: isViewDetails ? ['absolute', 'top-4', 'right-4', 'z-20'] : [],
        },
      }))
      const modal = document.querySelector('reusable-modal')
      const modalBody = modal.querySelector('.reusable-modal__body')
      modalBody.innerHTML = modalContent

      // iOS Safari specific fix for header positioning
      if (isViewDetails && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
        const modalHeader = modal.querySelector('.reusable-modal__header')
        if (modalHeader) {
          // Force a repaint to fix iOS rendering issues
          setTimeout(() => {
            modalHeader.style.display = 'none'
            modalHeader.style.display = 'block'
          }, 50)
        }
      }

      this.initializeModalComponents(modal)
    } catch (error) {
      console.error('Error opening variant modal:', error)
    } finally {
      const buttons = this.querySelectorAll('button')
      buttons.forEach(button => button.classList.remove('loading'))
      this.removeAttribute('loading')
    }
  }

  handleVariantSelectionModal () {
    const modalContent = this.buildVariantSelectionModal()
    window.dispatchEvent(new CustomEvent('open:modal', {
      detail: {
        width: '500px',
        padding: 'none',
        headerClassAdd: ['pt-2', 'px-4', 'block'],
        headerClassRemove: ['grid'],
        bodyClassAdd: ['relative', 'z-10'],
        footerClassAdd: ['p-4'],
        footerClassRemove: ['hidden', 'pb-4', 'md:pb-0', 'mt-4'],
        closeClassAdd: ['absolute', 'top-2', 'right-2', 'z-20'],
        showFooter: true,
      },
    }))

    console.log('disptached open:modal event')

    const modal = document.querySelector('reusable-modal')
    const modalTitle = modal.querySelector('.reusable-modal__title')
    if (modalTitle) {
      modalTitle.textContent = window.Tentbox.variantSelection.title
    }

    const modalBody = modal.querySelector('.reusable-modal__body')
    modalBody.innerHTML = modalContent

    const modalFooter = modal.querySelector('.reusable-modal__footer')
    if (modalFooter) {
      modalFooter.innerHTML = this.buildVariantSelectionFooter()
    }

    this.initializeVariantSelectionModal(modal)
  }

  buildVariantSelectionModal () {
    const variantType = this.dataset.variantType || 'colour'
    const instruction = window.Tentbox.variantSelection.instruction
      .replace('{variantType}', variantType)
      .replace('{productTitle}', this.productTitle)

    return `
      <style>
        .variant-selection-modal .product-info__variant-legend {
          display: none;
        }
        .variant-selection-modal .variant-modal__options fieldset {
          justify-content: center;
        }
      </style>
      <div class="variant-selection-modal p-4">
        <p class="text-black text-lg text-center mb-6">${instruction}</p>
        <div class="variant-modal__options">${this.variantOptions}</div>
      </div>
    `
  }

  buildVariantSelectionFooter () {
    return `
      <product-form>
        <form method="post" action="${window.routes.cart_add_url}" id="variant-selection-${this.productHandle}" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="id" value="${this.selectedVariantId}">
          <button type="submit" name="add" class="button button-primary w-full relative disabled:opacity-50 disabled:cursor-not-allowed" disabled>
            <span class="variant-modal-trigger__button-text">${window.Tentbox.variantSelection.select_variant}</span>
            <div class="loading-overlay__spinner loading-overlay__spinner--hidden absolute left-0 top-0 w-full h-full flex items-center justify-center bg-white/50">
              <div class="h-8 w-8 text-white animate-spin">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                </svg>
              </div>
            </div>
          </button>
        </form>
      </product-form>
    `
  }

  initializeVariantSelectionModal (modal) {
    const form = modal.querySelector('form')
    const button = form.querySelector('button[name="add"]')
    const optionInputs = modal.querySelectorAll('input[type="radio"]')

    // Deselect all variants to start
    optionInputs.forEach(input => {
      input.checked = false
    })

    // Disable add to cart button initially
    button.disabled = true
    button.querySelector('span').textContent = window.Tentbox.variantSelection.select_variant

    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        const selectedOptions = Array.from(modal.querySelectorAll('fieldset')).map((fieldset, optionIndex) => {
          const checkedInput = fieldset.querySelector('input:checked')
          if (!checkedInput) return null
          // Convert display value to original value using translation map
          return this.getOriginalValue(checkedInput.value, optionIndex + 1, modal)
        })

        const allOptionsSelected = selectedOptions.every(option => option !== null)
        const selectedVariant = this.variants.find(variant =>
          selectedOptions.every((option, index) =>
            variant[`option${index + 1}`] === option,
          ),
        )

        if (selectedVariant && allOptionsSelected) {
          const variantInput = form.querySelector('input[name="id"]')
          variantInput.value = selectedVariant.id
          button.disabled = !selectedVariant.available
          button.querySelector('span').textContent = selectedVariant.available ? (window.variantStrings?.addToCart || 'Add to cart') : (window.variantStrings?.soldOut || 'Sold out')
        } else {
          button.disabled = true
          button.querySelector('span').textContent = window.Tentbox.variantSelection.select_variant
        }
      })
    })
  }

  buildModalContent (productSection) {
    const hasVariants = this.hasVariants
    let mediaContent = ''
    if (hasVariants && this.variants && this.variants.length > 0) {
      const variantImages = this.variants.map(variant => {
        if (variant.featured_image) {
          return {
            id: variant.id,
            src: variant.featured_image.src,
            alt: variant.featured_image.alt || variant.title,
          }
        }
        return null
      }).filter(Boolean)
      mediaContent = `
        <variant-modal-carousel class="block">
          <div class="variant-carousel overflow-hidden">
            <div class="variant-carousel__viewport">
              <div class="variant-carousel__container">
                ${variantImages.map(image => `
                  <div class="variant-carousel__slide" data-variant-id="${image.id}">
                    <img src="${image.src}" alt="${image.alt}" width="500" height="300" class="w-full" />
                  </div>
                `).join('')}
              </div>
            </div>
          </div>
        </variant-modal-carousel>
      `
    } else {
      const featuredImageUrl = this.dataset.featuredImage
      if (featuredImageUrl) {
        mediaContent = `
          <div class="variant-modal__image">
            <img src="${featuredImageUrl}" alt="${this.productTitle}" width="500" height="300" class="w-full" />
          </div>
        `
      }
    }
    const formId = `product-form-${this.productHandle}`
    return `
      <style>
        .variant-carousel {
          --slide-spacing: 0;
          --slide-size: 100%;
          max-width: 500px;
          margin: 0 auto;
          user-select: none;
          pointer-events: none;
          position: relative;
          z-index: 1;
        }
        .variant-carousel__viewport {
          backface-visibility: hidden;
          user-select: none;
          pointer-events: none;
          touch-action: none;
        }
        .variant-carousel__container {
          display: flex;
          touch-action: none;
          margin-left: calc(var(--slide-spacing) * -1);
          user-select: none;
          pointer-events: none;
        }
        .variant-carousel__slide {
          flex: 0 0 var(--slide-size);
          padding-left: var(--slide-spacing);
          user-select: none;
          pointer-events: none;
        }
        .variant-carousel__slide img {
          width: 500px;
          height: 300px;
          object-fit: cover;
          user-select: none;
          pointer-events: none;
        }
        .variant-modal__image {
          position: relative;
          z-index: 1;
        }
        .loading-overlay__spinner:not(.loading-overlay__spinner--hidden) + .variant-modal-trigger__button-text {
          opacity: 0;
        }
        .variant-modal-trigger__button.loading .variant-modal-trigger__button-text {
          opacity: 0;
        }
      </style>
      <div class="variant-modal">
        ${mediaContent}
        <div class="variant-modal__content p-6">
          <h2 class="text-3xl font-medium">${this.productTitle}</h2>
          <div class="product-price">${this.priceMarkup}</div>
          ${hasVariants && this.variantOptions && this.variantOptions.trim() !== '' ? `<div class="variant-modal__options mb-4">${this.variantOptions}</div>` : ''}
          <div class="mb-4">${this.productDescription}</div>
          <div class="stock-status mb-4">${this.stockStatusMarkup}</div>
          <product-form>
            <form method="post" action="${window.routes.cart_add_url}" id="${formId}" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="id" value="${this.selectedVariantId}">
              <input type="hidden" name="product-id" value="${this.productHandle}">
              <button type="submit" name="add" class="variant-modal-trigger__button button button-primary w-full relative mb-4" ${!this.variants[0].available ? 'disabled' : ''} aria-haspopup="dialog">
                <span class="variant-modal-trigger__button-text">
                  ${this.variants[0].available ? (window.variantStrings?.addToCart || 'Add to cart') : (window.variantStrings?.soldOut || 'Sold out')}
                </span>
                <div class="loading-overlay__spinner loading-overlay__spinner--hidden absolute left-0 top-0 w-full h-full flex items-center justify-center bg-white/50">
                  <div class="h-8 w-8 text-white animate-spin">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                    </svg>
                  </div>
                </div>
              </button>
            </form>
          </product-form>
          <div class="product-link">${this.productLink}</div>
        </div>
      </div>
    `
  }

  initializeModalComponents (modal) {
    if (this.hasVariants) {
      const carouselOptions = {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
      }
      const carouselElement = modal.querySelector('.variant-carousel__viewport')
      const carousel = EmblaCarousel(carouselElement, carouselOptions)
      this.updateVariantSelection(modal, carousel)
      const optionInputs = modal.querySelectorAll('input[type="radio"]')
      optionInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updateVariantSelection(modal, carousel)
        })
      })
    }
  }

  updateVariantSelection (modal, carousel) {
    const selectedOptions = Array.from(modal.querySelectorAll('fieldset')).map((fieldset, optionIndex) => {
      const checkedInput = fieldset.querySelector('input:checked')
      if (!checkedInput) return null
      // Convert display value to original value using translation map
      return this.getOriginalValue(checkedInput.value, optionIndex + 1, modal)
    })
    const selectedVariant = this.variants.find(variant =>
      selectedOptions.every((option, index) =>
        variant[`option${index + 1}`] === option,
      ),
    )
    if (selectedVariant) {
      window.dispatchEvent(new CustomEvent('variant-modal:select-slide', {
        detail: { variantId: String(selectedVariant.id) },
      }))
      const form = modal.querySelector('form')
      const variantInput = form.querySelector('input[name="id"]')
      if (variantInput) {
        variantInput.value = selectedVariant.id
      }
      const button = form.querySelector('button[name="add"]')
      if (selectedVariant.available) {
        button.disabled = false
        button.querySelector('span').textContent = window.variantStrings?.addToCart || 'Add to cart'
      } else {
        button.disabled = true
        button.querySelector('span').textContent = window.variantStrings?.soldOut || 'Sold out'
      }
      const optionInputs = modal.querySelectorAll('input[type="radio"]')
      optionInputs.forEach(input => {
        // Find the option position for this input
        const fieldset = input.closest('fieldset')
        const fieldsets = Array.from(modal.querySelectorAll('fieldset'))
        const optionIndex = fieldsets.indexOf(fieldset) + 1

        const inputValue = this.getOriginalValue(input.value, optionIndex, modal)
        if (selectedVariant.options.includes(inputValue)) {
          input.checked = true
        }
      })
    }
  }

  getOriginalValue (displayValue, optionPosition, modal) {
    // Get translation map
    const translationMap = this.getTranslationMap(modal)
    if (!translationMap) return displayValue

    // Find the option by position
    const option = translationMap.options.find(opt => opt.position === optionPosition)
    if (!option) return displayValue

    // Find the value mapping
    const valueMapping = option.values.find(val => val.display === displayValue)
    if (!valueMapping) return displayValue

    return valueMapping.original || displayValue
  }

  getTranslationMap (modal) {
    if (!this.translationMap) {
      const mapElement = modal.querySelector('.variant-translation-map')
      if (mapElement) {
        try {
          this.translationMap = JSON.parse(mapElement.textContent)
        } catch (e) {
          console.warn('Failed to parse variant translation map:', e)
          this.translationMap = null
        }
      }
    }
    return this.translationMap
  }
}
class VariantModalCarousel extends HTMLElement {
  constructor () {
    super()
    this.carousel = null
  }

  connectedCallback () {
    this.initCarousel()
    this.setupEventListeners()
  }

  disconnectedCallback () {
    if (this.carousel) {
      this.carousel.destroy()
    }
  }

  initCarousel () {
    const viewport = this.querySelector('.variant-carousel__viewport')
    const container = this.querySelector('.variant-carousel__container')
    if (viewport && container) {
      const options = {
        active: true,
        align: 'start',
        loop: false,
        slidesToScroll: 1,
        containScroll: 'trimSnaps',
        draggable: false,
        dragFree: false,
        skipSnaps: false,
        watchDrag: false,
        speed: 0,
        startIndex: 0,
      }
      this.carousel = EmblaCarousel(viewport, options)
      const variantModalTrigger = document.querySelector('variant-modal-trigger')
      if (variantModalTrigger) {
        const initialVariantId = variantModalTrigger.dataset.selectedVariant
        const initialSlideIndex = this.getSlideIndexFromVariantId(initialVariantId)
        if (initialSlideIndex !== -1) {
          this.carousel.scrollTo(initialSlideIndex)
        }
      }
    }
  }

  setupEventListeners () {
    window.addEventListener('variant-modal:select-slide', (event) => {
      const { variantId } = event.detail
      const slideIndex = this.getSlideIndexFromVariantId(variantId)
      if (slideIndex !== -1 && this.carousel) {
        this.carousel.scrollTo(slideIndex)
      }
    })
  }

  getVariantIdFromSlide (index) {
    const slides = this.querySelectorAll('.variant-carousel__slide')
    return slides[index]?.dataset.variantId
  }

  getSlideIndexFromVariantId (variantId) {
    const slides = Array.from(this.querySelectorAll('.variant-carousel__slide'))
    return slides.findIndex(slide => slide.dataset.variantId === String(variantId))
  }
}
if (!customElements.get('variant-modal-trigger')) {
  customElements.define('variant-modal-trigger', VariantModalTrigger)
}
customElements.define('variant-modal-carousel', VariantModalCarousel)
